class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.button = this;
    this.productData = {
      id: this.dataset.id,
      title: this.dataset.title,
      handle: this.dataset.handle,
      var: this.dataset.var,
    };
    this.updateHeader();
    this.onClick = this.onClick.bind(this);
  }

  
  connectedCallback() {
    this.loadWishlist();
    if (this.wishlistArray.find(obj => obj.var === this.productData.var)) {
      this.classList.add('active');
    }
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  loadWishlist() {
    try {
      const cookieValue = document.cookie.match('(^|;) ?wishlist=([^;]*)(;|$)');
      this.wishlistArray = cookieValue ? JSON.parse(cookieValue[2]) : [];
    } catch (err) {
      console.warn('Invalid wishlist cookie:', err);
      this.wishlistArray = [];
    }
  }

  saveWishlist() {
    const arrayString = JSON.stringify(this.wishlistArray);
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    document.cookie = `wishlist=${arrayString}; expires=${expirationDate.toUTCString()}; path=/`;
  }

  updateHeader() {
    this.loadWishlist(); 
    
    const allWishHeadLinks = document.querySelectorAll('.wishlist_link');
    allWishHeadLinks.forEach(link => {
      const bubble = link.querySelector('.wishlist-bubble');
      if (this.wishlistArray.length) {
        link.classList.add('active');
        if (bubble) {
          bubble.classList.remove('hide');
          bubble.innerText = this.wishlistArray.length;
        }
      } else {
        link.classList.remove('active');
        if (bubble) {
          bubble.classList.add('hide');
          bubble.innerText = '';
        }
      }
    });
  }

  loadAllData() {
    const all_wishlist = document.querySelectorAll('wishlist-product');

    all_wishlist.forEach(single_ele =>{
      const exists = this.wishlistArray.find(obj => obj.var === single_ele.dataset.var);
      if (exists) {
        single_ele.classList.add('active');
      } else {
        single_ele.classList.remove('active');
      }
    })
  }

  onClick() {
    this.loadWishlist();
    
    this.productData = {
      id: this.dataset.id,
      title: this.dataset.title,
      handle: this.dataset.handle,
      var: this.dataset.var,
    };
    
    const exists = this.wishlistArray.find(obj => obj.var === this.productData.var);
    console.log("exists--", exists);
    if (exists) {
      this.wishlistArray = this.wishlistArray.filter(obj => obj.var !== this.productData.var);
      this.classList.remove('active');
      const productCard = this.closest('.page-wishlist .grid__item.grid-product');
      if (productCard) productCard.remove();
      this.loadAllData();
    } else {
      this.wishlistArray.push(this.productData);
      this.classList.add('active');
    }

    this.saveWishlist();
    this.updateHeader();    

    const parentElement = document.querySelector('.grid.product-grid.wishlist');
    const pageWishlistLink = document.getElementById('page-wishlist-link');
    const pageWishlistHead = document.getElementById('page-wishlist-head');
    const pageWishlistEmptyHead = document.getElementById('page-wishlist-empty-head');

    if (parentElement && parentElement.children.length === 0) {
      pageWishlistLink?.style.setProperty('display', 'flex');
      pageWishlistEmptyHead?.style.setProperty('display', 'block');
      pageWishlistHead?.style.setProperty('display', 'none');
    }

    var all_count_ele = document.querySelectorAll('wishlist-count');
    var all_count_ele_brac = document.querySelectorAll('wishlist-count-brac');
    var wishlistValue_before = document.cookie.match('(^|;) ?wishlist=([^;]*)(;|$)');
    var wishlistArrayValues_before = wishlistValue_before ? JSON.parse(wishlistValue_before[2]) : [];

    if(all_count_ele.length > 0 ) {
      if(wishlistArrayValues_before.length > 0) {
        all_count_ele.forEach(single_ele => {
          single_ele.innerHTML = wishlistArrayValues_before.length;
        })
      } else {
        all_count_ele.forEach(single_ele => {
          single_ele.innerHTML = '';
        })
      }
    }
    if(all_count_ele_brac.length > 0 ) {
      if(wishlistArrayValues_before.length > 0) {
        all_count_ele_brac.forEach(sin_ele => {
          sin_ele.innerHTML = `(${wishlistArrayValues_before.length})`;
        })
      } else {
        all_count_ele_brac.forEach(sin_ele => {
          sin_ele.innerHTML = '';
        })
      }
    }
  }
}

customElements.define('wishlist-product', WishlistProduct);